if (!customElements.get('size-tables')) {
  class SizeTables extends HTMLElement {
    constructor() {
      super();
      this.unit = 'cm';
      this.category = 'top';

      const dataScript = this.querySelector('script[type="application/json"]');
      this.data = dataScript ? JSON.parse(dataScript.textContent) : {};

      this.tableEl = this.querySelector('[data-st-table]');
      this.metaEl = this.querySelector('[data-st-meta]');
      this.heightEl = this.querySelector('[data-st-height]');
      this.heightRowsEl = this.querySelector('[data-st-height-rows]');

      this._bind();
      this._render();
    }

    _bind() {
      this.querySelectorAll('[data-st-cat]').forEach((btn) => {
        btn.addEventListener('click', () => this._setCategory(btn.dataset.stCat));
      });
      this.querySelectorAll('[data-st-unit]').forEach((btn) => {
        btn.addEventListener('click', () => this._setUnit(btn.dataset.stUnit));
      });
    }

    _setCategory(cat) {
      if (cat === this.category) return;
      this.category = cat;
      this.querySelectorAll('[data-st-cat]').forEach((btn) => {
        const on = btn.dataset.stCat === cat;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this._render();
    }

    _setUnit(unit) {
      if (unit === this.unit) return;
      this.unit = unit;
      this.dataset.activeUnit = unit;
      this.querySelectorAll('[data-st-unit]').forEach((btn) => {
        const on = btn.dataset.stUnit === unit;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this._render();
    }

    _render() {
      const cat = this.data[this.category];
      if (!cat) return;

      const measures = cat.measurements || [];
      const headers = ['Size', 'UK', 'EU', 'US', ...measures.map((m) => m.charAt(0).toUpperCase() + m.slice(1))];
      const keys = ['size', 'uk', 'eu', 'us', ...measures.map((m) => m + '_' + this.unit)];

      let html = '<table class="st-table"><thead><tr>';
      headers.forEach((h) => { html += '<th>' + h + '</th>'; });
      html += '</tr></thead><tbody>';
      cat.rows.forEach((row) => {
        html += '<tr>';
        keys.forEach((k) => { html += '<td>' + (row[k] || '') + '</td>'; });
        html += '</tr>';
      });
      html += '</tbody></table>';
      this.tableEl.innerHTML = html;

      if (this.metaEl) {
        const sizingNote = cat.sizing === 'dual' ? 'Dual-size (one piece spans two UK sizes).' : 'Single-size.';
        this.metaEl.textContent = cat.label + ' — body measurements. ' + sizingNote;
      }

      if (cat.has_height && cat.height_info) {
        this.heightEl.hidden = false;
        const labels = { petite: 'Petite', regular: 'Regular', tall: 'Tall' };
        this.heightRowsEl.innerHTML = Object.entries(cat.height_info)
          .map(([k, v]) => '<div class="st-height__row"><span class="st-height__label">' + (labels[k] || k) + '</span><span class="st-height__value">' + v + '</span></div>')
          .join('');
      } else {
        this.heightEl.hidden = true;
        this.heightRowsEl.innerHTML = '';
      }
    }
  }

  customElements.define('size-tables', SizeTables);
}
